import React, { Component } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Icon, List, Segment } from 'semantic-ui-react';
import { ApplicationState } from '../..';
import { MatricolaCarrello, OrdineRiga } from '../models';
import * as Ordini from '..';

const connector = connect(
    (state: ApplicationState) => ({ 
        carrelloConsumabili: state.ordini.carrelloConsumabili 
    }),
    Ordini.actions,
)

type PropsFromRedux = ConnectedProps<typeof connector>

type CustomProps = {
    attached: boolean
}

type RiepilogoOrdineProps = 
    PropsFromRedux &
    CustomProps

class RiepilogoOrdine extends Component<RiepilogoOrdineProps> {
    constructor(props: RiepilogoOrdineProps) {
        super(props);

        this.renderMatricola = this.renderMatricola.bind(this);
        this.deleteConsumabile = this.deleteConsumabile.bind(this);
    }

    renderMatricola(matricola: MatricolaCarrello) {
        return (
            <List.Item key={matricola.matricola.idSpecifica}>
                <List.Icon name="print" />
                <List.Content>
                    <List.Header>Matricola : {matricola.matricola.codice}</List.Header>
                    <List.List>
                        {matricola.righe.map(consumabile => {
                            return (
                                <List.Item key={consumabile.codice}>
                                    <List.Content>
                                        <List.Description>
                                            <List.Icon onClick={() => this.deleteConsumabile(matricola.matricola.idSpecifica, consumabile)} style={{float: 'left', cursor: 'pointer'}}>
                                                <Icon name='trash alternate outline' color='red'></Icon>
                                            </List.Icon>
                                            <strong>{consumabile.quantita}</strong> {consumabile.descrizione}
                                        </List.Description>
                                    </List.Content>
                                </List.Item>
                            );
                        })}
                    </List.List>
                </List.Content>
            </List.Item>);
    }

    render() {
        const { carrelloConsumabili, attached } = this.props;
        return (
            <Segment attached={attached}>
                <List>
                    {carrelloConsumabili.lista.map(this.renderMatricola)}
                </List>
            </Segment>
        );
    }

    deleteConsumabile(idSpecifica: string, consumabile: OrdineRiga) {
        this.props.rimuoviConsumabile(idSpecifica, consumabile);
    }
}

export default connector(RiepilogoOrdine);
